import { createMuiTheme } from '@material-ui/core';
//#d1ae52
//rowUnfolded: '#FFD799',
const brand = {
  tabNormal: '#123b4d',
  tabSelect: '#d1ae52',
  tabSelectBack: '#b6b8ba',
  tabBack: '#e4e5e6',
  black54: '#8c8e90',
  black89: '#434345',
  rowUnfolded: '#d1ae52',
  rowSelected: '#d1ae52',
};

// Default theme
const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
});

const colors = {
  rangeSliderColor: '#005277',
  tableHeader: brand.tabBack,
  pageFooter: brand.tabBack,
  logo: '#085375',
  searchInput: {
    backgroundColor: '#fff',
  },
  searchInputWithSelect: {
    select: {},
  },
  searchPage: {
    tabSelectedBackground: brand.tabSelectBack,
    tabBackground: brand.tabBack,
    filterBackground: '#F8F5F0',
    weightValueBorder: '#C4C6C8',
    ratingIconColor: '#C4C6C8',
    deliveryTermLabel: '#fff',
    uploadFileButton: {},
    downloadTemplateButton: {},
    table: {
      unfoldedRow: brand.rowUnfolded,
      selectedRow: brand.rowSelected,
    },
    excelButton: {
      fontColor: '#fff',
      default: brand.tabNormal,
      hovered: '#085375',
      focused: '#92AC90',
    },
  },
  basketPage: {
    orderButton: {},
    deleteButton: {},
    excelButton: {
      fontColor: '#fff',
      default: brand.tabNormal,
      hovered: '#085375',
      focused: '#92AC90',
    },
    table: {
      unfoldedRow: brand.rowUnfolded,
      selectedRow: brand.rowSelected,
    },
  },
  catalogPage: {
    table: {
      unfoldedRow: brand.rowUnfolded,
      selectedRow: brand.rowSelected,
    },
  },
  ordersPage: {
    excelButton: {
      fontColor: '#fff',
      default: brand.tabNormal,
      hovered: '#085375',
      focused: '#92AC90',
    },
  },
  shipmentsPage: {
    table: {
      unfoldedRow: brand.rowUnfolded,
      selectedRow: brand.rowSelected,
    },
    shipmentDateDialog: {
      dialog: 'initial',
      textField: {
        background: 'initial',
      },
      button: {},
    },
    totalTable: {
      button: {},
    },
  },
  balancePage: {
    excelButton: {
      fontColor: '#fff',
      default: brand.tabNormal,
      hovered: '#085375',
      focused: '#92AC90',
    },
  },
  pageHeader: {
    header: '#fff',
    loginButton: {},
    signUpButton: {},
  },
  pageTabs: {
    tab: brand.tabNormal,
    tabSelected: brand.tabSelect,
  },
  resetPasswordPage: {
    dialog: brand.tabBack,
    textField: {
      background: '#fff',
    },
  },
  loginDialog: {
    dialog: '#fff',
    textField: {
      background: '#fff',
    },
    forgotPassword: {
      color: theme.palette.text.primary,
    },
    button: {
      fontColor: '#fff',
      default: '#bc312e',
      hovered: '#EF6A3D',
      disabled: '#bc312e',
    },
  },
  signUpDialog: {
    dialog: '#fff',
    textField: {
      background: '#fff',
    },
    errorChip: {
      color: '#fff',
    },
  },
  userDataDialog: {
    dialog: '#fff',
    textField: {
      background: '#fff',
    },
    errorChip: {
      color: '#fff',
    },
  },
};

const halfSpacingUnit = theme.spacing.unit / 2;

export default createMuiTheme({
  spacing: {
    halfUnit: halfSpacingUnit,
  },
  typography: {
    useNextVariants: true,
    fontFamily: ['Montserrat', 'sans-serif'],
  },
  palette: {
    background: {
      default: '#fff',
    },
    custom: { ...colors },
    primary: {
      main: brand.tabSelect,
      contrastText: '#fff',
    },
  },
  shape: {
    borderRadius: theme.shape.borderRadius / 2,
  },
  overrides: {
    MuiTableHead: {
      root: {
        background: colors.tableHeader,
        position: "sticky",
        top: '0',
        'z-index': '10',
      },
    },
    MuiTableRow: {
      root: {
        height: '40px',
      },
      head: {
        height: '40px',
      },
    },
    MuiTableCell: {
      root: {
          paddingRight: theme.spacing.unit / 2,
      },
      body: {
        fontSize: theme.typography.pxToRem(12),
      },
      head: {
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
      },
    },
    MuiButton: {
      root: {
        whiteSpace: 'nowrap',
      },
      contained: {
        boxShadow: 'none',
        // '&$disabled': {
        //   backgroundColor: '#C4C6C8',
        //   color: '#fff',
        // },
      },
    },
    MuiTab: {
      root: {
        cursor: 'pointer',
        // [theme.breakpoints.up('md')]: {
        //   fontSize: theme.typography.pxToRem(13),
        //   minWidth: 120,
        // },
      },
    },
    MuiPrivateTabIndicator: {
      root: {
        height: 0,
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#fff',
      },
    },
    MuiPickersToolbarButton: {
      toolbarBtn: {
        color: theme.palette.text.primary,
      },
      toolbarBtnSelected: {
        color: theme.palette.text.primary,
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        color: theme.palette.text.primary,
      },
      dayLabel: {},
    },
    MuiPickersCalendar: {
      transitionContainer: {
        minHeight: '168px',
      },
    },
    MuiPickersDay: {
      day: {
        color: theme.palette.text.primary,
        borderRadius: 'initial',
        height: '28px',
      },
      isSelected: {
        backgroundColor: brand.orange,
      },
      current: {},
    },
    MuiCheckbox: {
      colorSecondary: {
        color: brand.tabNormal,
        '&$checked': {
          color: brand.tabNormal,
        },
      },
    },
  },
  props: {
    MuiTable: {
      padding: 'default',
      size: 'small',
    },
    MuiTableCell: {
      align: 'center',
    },
    MuiTableRow: {},
    MuiInputBase: {
      margin: 'dense',
    },
  },
  tableContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    overflowX: 'auto',
  },
});
